import { Moment } from './moment';

const monthAbbrivation = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
export const oneDayInUnix = 24 * 60 * 60 * 1000;

export const yearMonthDayFormat = time => {
  if (!time) return time;
  const { year, month, date } = new Moment(time).getDateDetails();

  return `${year}/${month}/${date}`;
};

export const addMonth = (time, monthDiff = 0) => {
  // use 30 days for one month to calculate at current version.
  // This may be changed after confirmed, cause next credit card charged date is not controlled by us.
  const unix = new Moment(time).getTime() + monthDiff * 30 * oneDayInUnix;
  const { year, month, date } = new Moment(unix).getDateDetails();

  return `${year}-${month}-${date}`;
};

// MMMMM DD, YYYY e.g. Aug 22, 1992
export const academyArticleFormat = time => {
  const { year, month, date } = new Moment(time).getDateDetails();

  return `${monthAbbrivation[month - 1]} ${date}, ${year}`;
};



// WEBPACK FOOTER //
// ./app/utils/dateParser.js